import { setUnifiedError } from "../../partnerCentralUtils";

let S = com.ts.mobile.sdk;
export default class BaseAuthenticatorSession {
  constructor(title, username, helper) {
    this.title = title;
    this.username = username;
    this.helper = helper;
  }

  helper() {
    return this.helper;
  }

  presentUI(htmlElement) {
    this.helper.presentUI(htmlElement, this.clientContext);
  }
  startSession(description, mode, actionContext, clientContext) {
    this.description = description;
    this.mode = mode;
    this.actionContext = actionContext;
    this.uiContext = actionContext.getUiContext();
    this.clientContext = clientContext;
  }
  promiseInput() {
    switch (this.mode) {
      case S.AuthenticatorSessionMode.Authentication:
        return this.promiseAuthInput();
      case S.AuthenticatorSessionMode.Registration:
        return this.promiseRegInput();
    }
  }
  endSession() {
  }
  changeSessionModeToRegistrationAfterExpiration() {
    this.mode = S.AuthenticatorSessionMode.Registration;
  }
  promiseRecoveryForError(error, validRecoveries, defaultRecovery) {
    let failureMessage = "Error: " + error.getMessage();
    let errorData = error.getData();

    const isUnifiedLogin = this.helper.getContext().localeCompare("login") === 0
    const isUnifiedForgotPassword = this.helper.getContext().localeCompare("app") === 0
    const retriesLeft = errorData?.additional_data.retries_left


    if (
      errorData &&
      errorData.additional_data &&
      errorData.additional_data?.locked
    ) {

      failureMessage = `Authenticator locked: ${failureMessage}`;


    } else if (isUnifiedLogin && retriesLeft === 0) {
      console.error(`Authenticator locked: ${failureMessage}`)
      setUnifiedError("Sign in has been temporarily disabled due to too many attempts. Try again in 10 minutes.")
      return Promise.resolve(S.AuthenticationErrorRecovery.Fail);
    }



    if ((isUnifiedLogin || isUnifiedForgotPassword) && retriesLeft > 0) {
      const attemptOrAttempts = retriesLeft > 1 ? "attempts" : "attempt"

      // if in login and retries are available, set error and do not end session
      setUnifiedError(`That access code is incorrect. Please try again. 
            You have ${retriesLeft} ${attemptOrAttempts} remaining`)
      return Promise.resolve(S.AuthenticationErrorRecovery.RetryAuthenticator)
    }
    else if ((isUnifiedLogin || isUnifiedForgotPassword) && !retriesLeft) {

      return Promise.resolve(S.AuthenticationErrorRecovery.Fail);
    }


    let getTitle = (option) => {
      switch (option) {
        case S.AuthenticationErrorRecovery.RetryAuthenticator:
          return this.uiContext.getString("ts_gen_retry_authenticator");
      }
    };


    let menuItems = validRecoveries.map((recovery) => {
      return {
        title: getTitle(recovery),
        value: recovery,
      };
    });
    return this.helper.presentSelectionUI(
      menuItems,
      `${error.getMessage()}`,
      null,
      this.clientContext
    );
  }

  promiseCancelAction(options, clientContext) {

    let getTitle = (option) => {
      switch (option) {
        case S.ControlRequestType.ChangeMethod:
          return "Change Authentication Method";
        case S.ControlRequestType.SelectMethod:
          return "Show All Authentication Methods";
        case S.ControlRequestType.RetryAuthenticator:
          return "Retry Authenticator";
        case S.ControlRequestType.AbortAuthentication:
          return "Abort Authentication";
      }
    };

    let menuItems = options.map((option) => {
      return {
        title: getTitle(option),
        value: S.ControlRequest.create(option),
      };
    });


  }
}
